export default {
  mfaStatus: {
    available: 'available',
    unavailable: 'unavailable',
    not_configured: 'not_configured',
  },

  mfaNames: {
    duo: 'duo',
    push: 'push',
    totp: 'totp',
    webauthn: 'webauthn',
  },
};
